import { AfterViewInit, Component, ViewChild, ElementRef } from '@angular/core';

@Component({
  selector: 'app-supplier-autocomplete-editor',
  template: `
    <div style="background: white; border: 1px solid #babfc7; box-shadow: 0 1px 4px 1px rgba(186,191,199,0.4); min-width: 180px;">
      <div style="padding: 4px;">
        <input
          #searchInput
          type="text"
          [(ngModel)]="searchText"
          (input)="onInput()"
          (keydown)="onKeyDown($event)"
          placeholder="Search..."
          style="width: 100%; padding: 4px 6px; border: 1px solid #babfc7; box-sizing: border-box; font-size: 13px; font-family: inherit; outline: none;"
        />
      </div>
      <div style="max-height: 200px; overflow-y: auto;">
        <div
          *ngFor="let option of filteredOptions; let i = index"
          (mousedown)="selectOption(option)"
          (mouseover)="selectedIndex = i"
          [style.background]="i === selectedIndex ? '#CF4B00' : 'white'"
          [style.color]="i === selectedIndex ? 'white' : '#181d1f'"
          style="padding: 6px 10px; cursor: pointer; font-size: 13px; font-family: inherit; white-space: nowrap;"
        >
          {{ option }}
        </div>
        <div *ngIf="filteredOptions.length === 0"
             style="padding: 6px 10px; color: #999; font-size: 13px; font-family: inherit;">
          No results
        </div>
      </div>
    </div>
  `
})
export class SupplierAutocompleteEditorComponent implements AfterViewInit {
  params: any;
  value: any;
  searchText = '';
  allOptions: string[] = [];
  filteredOptions: string[] = [];
  selectedIndex = -1;

  @ViewChild('searchInput') searchInput: ElementRef;

  ngAfterViewInit() {
    setTimeout(() => this.searchInput.nativeElement.focus());
  }

  agInit(params: any): void {
    this.params = params;
    this.value = params.value || '';
    this.searchText = '';
    this.allOptions = params.values || [];
    this.filteredOptions = [...this.allOptions];
  }

  onInput() {
    const term = this.searchText.toLowerCase().trim();
    this.filteredOptions = term
      ? this.allOptions.filter(o => o.toLowerCase().includes(term))
      : [...this.allOptions];
    this.selectedIndex = -1;
  }

  onKeyDown(event: KeyboardEvent) {
    if (event.key === 'ArrowDown') {
      event.preventDefault();
      this.selectedIndex = Math.min(this.selectedIndex + 1, this.filteredOptions.length - 1);
    } else if (event.key === 'ArrowUp') {
      event.preventDefault();
      this.selectedIndex = Math.max(this.selectedIndex - 1, 0);
    } else if (event.key === 'Enter') {
      const chosen = this.selectedIndex >= 0
        ? this.filteredOptions[this.selectedIndex]
        : this.filteredOptions.length === 1 ? this.filteredOptions[0] : null;
      if (chosen) this.selectOption(chosen);
      else this.params.stopEditing();
    } else if (event.key === 'Escape') {
      this.params.stopEditing(true);
    }
  }

  selectOption(option: string) {
    this.value = option;
    this.params.stopEditing();
  }

  getValue() { return this.value; }

  isPopup() { return true; }  // positions it below the cell, same as agRichSelectCellEditor
}